import React from "react";
import Banner from "../../components/Banner/Banner";
import CoinsTable from "../../components/CoinsTable/CoinsTable";

const Home = () => {
  return (
    <>
      <Banner />
      <CoinsTable />
    </>
  );
};

export default Home;
